import React from "react";
import { Box, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { AzureStorage } from "../../../../../types/targetStorageTypes";
import { SOCIAL_ACCOUNT_BUTTON_WIDTH } from "../../../../../constants/styles";

const AzureStorageForm: React.FC<any> = ({ account, mode, onFieldChange, onCreate, onUpdate, onDelete, onChangeMode }) => {
    const azureAccount = account as AzureStorage;
    const isReadonly = mode === 'readonly';

    return (
        <Box >
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Name" value={azureAccount.name} disabled={isReadonly} onChange={(e) => onFieldChange('name', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Account Name" value={azureAccount.account_name} disabled={isReadonly} onChange={(e) => onFieldChange('account_name', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Container Name" value={azureAccount.container_name} disabled={isReadonly} onChange={(e) => onFieldChange('container_name', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField fullWidth label="Prefix (Optional)" value={azureAccount.prefix} disabled={isReadonly} onChange={(e) => onFieldChange('prefix', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                        fullWidth
                        label="SAS Token"
                        type="password"
                        value={isReadonly ? (azureAccount.id ? '********' : '') : (azureAccount.sas_token || '')}
                        disabled={isReadonly}
                        onChange={(e) => onFieldChange('sas_token', e.target.value)}
                    />
                </Grid>
            </Grid>
            <Box sx={{ mt: 2, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                {isReadonly ? (
                    <>
                        <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<DeleteIcon />} onClick={onDelete}>Delete</Button>
                        <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<EditIcon />} onClick={() => onChangeMode('updatable')}>Edit</Button>
                    </>
                ) : (
                    <>
                        {azureAccount.id && <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<CloseIcon />} onClick={() => onChangeMode('readonly')}>Cancel</Button>}
                        <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<SaveIcon />} onClick={azureAccount.id ? onUpdate : onCreate}>
                            {azureAccount.id ? 'Save' : 'Create'}
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default AzureStorageForm;